import React from "react";
import { PieChart as Pie } from "react-minimal-pie-chart";

export default function PieChart(props) {
  return <Pie style={{ height: "25rem", marginTop: "2%" }} data={props.data} />;
}
